var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DomHelper, iconClosedGroup, iconOpenGroup } from "./domHelper";
import { getShopBackendData, sendShopBackendData } from "./xhrbackend";
import { Util } from "./util";
import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
import { marked } from 'marked';
let store;
let refreshProducts;
export function appWebshop(globalStore, username, bearerToken, userPreferences, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appWebshop");
    store = globalStore;
    const additionalClassList = [];
    const idString = 'rudi-webshop-app';
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    let content = "";
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, event => {
        store.bearerToken = bearerToken;
        store.lastOrderFetch = null;
        store.startDate = null;
        refreshProducts = true;
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.add('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            const appConfig = JSON.parse(app.odAppConfig);
            fullScreenNode.classList.remove('disabled');
            const headerNode = DomHelper.appendNode(fullScreenNode, 'header', []);
            DomHelper.appendNode(headerNode, 'h1', [], [], appConfig.title ? appConfig.title : "IT Webshop");
            const btnNode = DomHelper.appendNode(headerNode, 'div', ['od-button-area']);
            DomHelper.createButtonClose(btnNode, username, bearerToken, userPreferences);
            const recentOrderListPane = DomHelper.appendNode(fullScreenNode, 'section', ['disabled'], [], '', 'odRecentOrderListPane');
            const webshopPane = DomHelper.appendNode(fullScreenNode, 'section', [], [], '', 'odWebshopPane');
            const listNode = DomHelper.appendNode(webshopPane, 'section', [], [], "", "odWebshopList");
            addSkeletonCards(listNode, username, bearerToken, userPreferences, 10);
            const cartNode = DomHelper.appendNode(webshopPane, 'section', [], [], "", "odWebshopCart");
            getShopBackendData("", "/products", "GET", "application/json", bearerToken, function (response) {
                const productResponseData = JSON.parse(response.target.response);
                setTimeout(() => {
                    getShopBackendData("", `/search/users/?username=${username}`, "GET", "application/json", bearerToken, function (response) {
                        if (response.target.status === 200) {
                            const responseRaw = JSON.parse(response.target.response);
                            const responseData = responseRaw.objectList;
                            const userid = responseData[0].id;
                            store.shopUserId = userid;
                            createButtonRefresh(btnNode, userid, bearerToken, userPreferences);
                            removeSkeletonCards(listNode);
                            productListRender(listNode, userid, bearerToken, userPreferences, productResponseData, false);
                            const allProductList = productResponseData.productList;
                            captureSearchBar(allProductList);
                            DomHelper.disableDefaultNav();
                            injectWebshopNav();
                            getShopBackendData("", `/shoppingcart/${userid}/items`, "GET", "application/json", bearerToken, function (response) {
                                const responseData = JSON.parse(response.target.response);
                                cartRender(cartNode, userid, bearerToken, userPreferences, responseData, allProductList);
                            });
                        }
                        else {
                            console.error("error connecting to backend and trying to get Userid");
                        }
                    });
                }, 0);
            });
            const orderScreen = document.getElementById("odRecentOrderListPane");
            if (!orderScreen) {
                return;
            }
            renderOrderStructure(orderScreen);
        }
    });
}
function refreshWebshop(bearerToken, userid, userPreferences, buttonNode) {
    buttonNode.disabled = true;
    if (refreshProducts) {
        const listNode = document.getElementById("odWebshopList");
        const cartNode = document.getElementById("odWebshopCart");
        const cartPane = document.getElementById("odWebshopPane");
        if (listNode)
            listNode.innerHTML = "";
        if (cartNode)
            cartNode.innerHTML = "";
        if (cartPane)
            cartPane.classList.remove('showcart');
        getShopBackendData("", "/products", "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            productListRender(listNode, userid, bearerToken, userPreferences, responseData, false);
            const allProductList = responseData.productList;
            captureSearchBar(allProductList);
            DomHelper.disableDefaultNav();
            injectWebshopNav();
            getShopBackendData("", `/shoppingcart/${userid}/items`, "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                cartRender(cartNode, userid, bearerToken, userPreferences, responseData, allProductList);
                buttonNode.disabled = false;
            });
        });
        return;
    }
    console.log("Start Refreshing orderListnode");
    const orderListNode = document.getElementById("odWebshopOrderList");
    orderListNode.innerHTML = "";
    store.lastOrderFetch = null;
    store.startDate = null;
    renderOrderData().then(() => {
        console.log("Data loaded");
        buttonNode.disabled = false;
    });
}
function isOlderThan30Minutes(value) {
    const dateTime = new Date(value).getTime();
    if (isNaN(dateTime)) {
        return false;
    }
    const now = new Date().getTime();
    const thirtyMinutesInMs = 30 * 60 * 1000;
    const difference = now - dateTime;
    console.log(difference);
    console.log(difference);
    console.log((difference > thirtyMinutesInMs));
    return (now - dateTime) > thirtyMinutesInMs;
}
function enableOrderHistory(e) {
    return __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        const orderScreen = document.getElementById("odRecentOrderListPane");
        if (!orderScreen) {
            return;
        }
        const odWebshopPane = document.getElementById("odWebshopPane");
        odWebshopPane.classList.add('disabled');
        orderScreen.classList.remove('disabled');
        refreshProducts = false;
        captureOrderSearchbar();
        if (store.lastOrderFetch == null || isOlderThan30Minutes(store.lastOrderFetch)) {
            console.log("load from endableOrderHistory");
            const orderList = document.getElementById("odWebshopOrderList");
            const skeletonList = document.getElementById("odOrderSkeletonList");
            skeletonList.classList.remove('disabled');
            renderSkeletonCards(skeletonList, 3);
            orderList.innerHTML = "";
            store.lastOrderFetch = null;
            renderOrderData().finally(() => {
                console.log("renderOrderData.finally() => loaded");
                skeletonList.classList.add('disabled');
            });
        }
    });
}
function renderSkeletonCards(orderSkeletonList, amount) {
    orderSkeletonList.innerHTML = "";
    for (let i = 0; i < amount; i++) {
        const skeletonCard = DomHelper.appendNode(orderSkeletonList, "article", ["od-order-card-skeleton"]);
        appendSkeletonHeader(skeletonCard);
        const randomRowNumber = getRandomNumber(4);
        for (let r = 0; r < randomRowNumber; r++) {
            console.warn(`Random Number: ${randomRowNumber}`);
            appendSkeletonRow(skeletonCard);
        }
    }
}
function getRandomNumber(max) {
    return (Math.floor(Math.random() * max) + 1);
}
function appendSkeletonHeader(skeletonCard) {
    const header = DomHelper.appendNode(skeletonCard, "section", ["od-order-card-skeleton-header"]);
    const headerLines = DomHelper.appendNode(header, "div", ["od-order-card-skeleton-header-lines"]);
    appendSkeletonBlock(headerLines, { width: "220px", height: "18px" });
    appendSkeletonBlock(headerLines, { width: "280px", height: "12px" });
    appendSkeletonBlock(header, { width: "60px", height: "12px" });
}
function appendSkeletonRow(skeletonCard) {
    const row = DomHelper.appendNode(skeletonCard, "section", ["od-order-card-skeleton-row"]);
    appendSkeletonCell(row, [
        { width: "80%", height: "14px" },
        { width: "50%", height: "11px" },
    ]);
    appendSkeletonCell(row, [
        { width: "70%", height: "14px" },
    ]);
    appendSkeletonCell(row, [
        { width: "90%", height: "11px" },
        { width: "60%", height: "11px" },
        { width: "70%", height: "11px" },
    ]);
    appendSkeletonCell(row, [
        { width: "60%", height: "14px" },
    ]);
    appendSkeletonCell(row, [
        { width: "50px", height: "20px", borderRadius: "20px" },
    ]);
}
function appendSkeletonCell(skeletonRow, blocks) {
    const cell = DomHelper.appendNode(skeletonRow, "section", ["od-order-card-skeleton-cell"]);
    blocks.forEach(block => appendSkeletonBlock(cell, block));
}
function appendSkeletonBlock(parent, config) {
    const block = DomHelper.appendNode(parent, "div", ["od-order-card-skeleton-block"]);
    block.style.width = config.width;
    block.style.height = config.height;
    if (config.borderRadius) {
        block.style.borderRadius = config.borderRadius;
    }
    return block;
}
function renderOrderData() {
    return new Promise((resolve, reject) => {
        const orderList = document.getElementById("odWebshopOrderList");
        console.log(`Last Fetch: ${store.lastOrderFetch}
    `);
        let user = store.shopUserId;
        let bearerToken = store.bearerToken;
        let start = store.startDate ? new Date(store.startDate) : new Date();
        let end = new Date(start);
        end.setDate(end.getDate() - 90);
        const startDate = getGermanIsoString(start);
        const endDate = getGermanIsoString(end);
        console.log(`StartDate: ${startDate}`);
        console.log(`EndDate: ${endDate}`);
        getShopBackendData("", `/orders/${user}/?startDate=${startDate}&endDate=${endDate}`, "GET", "application/json", bearerToken, function (response) {
            store.startDate = endDate;
            if (response.target.status !== 200) {
                DomHelper.showMessage({
                    appcn: "",
                    appdn: "",
                    duration: 5000,
                    header: "Error",
                    icon: "fa-cart-circle-xmark",
                    message: "Die Bestell History konnte nicht geladen werden",
                    type: 'error',
                    version: ""
                }, null, bearerToken);
                reject(new Error("order fetch failed"));
                return;
            }
            store.lastOrderFetch = new Date().toISOString();
            const responseRaw = JSON.parse(response.target.response);
            const orderResponse = responseRaw;
            if (orderResponse.length > 0) {
                orderResponse.forEach((order) => {
                    console.log(`Render for Order: ${order.cartId}`);
                    if (!order.items || !order.items.meta || order.items.meta.totalNumber === 0) {
                        renderOrderCardNoItems(orderList, order);
                    }
                    else {
                        renderOrderCard(orderList, order);
                    }
                });
            }
            else {
                console.log("not found");
                renderNotFoundCard(orderList, startDate, endDate);
            }
            resolve();
        });
    });
}
function getGermanIsoString(date) {
    const formatter = new Intl.DateTimeFormat('sv-SE', {
        timeZone: 'Europe/Berlin',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return formatter.format(date).replace(' ', 'T');
}
function setButtonLoading(isLoading) {
    const btn = document.getElementById("odOrderLoadMore");
    const btnLabel = btn.querySelector(".od-btn-label");
    btn.disabled = isLoading;
    btn.classList.toggle('od-is-loading', isLoading);
    btnLabel.textContent = isLoading ? "Lade Daten..." : "Weitere 90 Tage laden";
}
function renderOrderStructure(orderScreen) {
    const orderHeader = DomHelper.appendNode(orderScreen, "section", ["od-order-header"]);
    renderOrderHeader(orderHeader);
    DomHelper.appendNode(orderScreen, "section", ["od-order-skeleton-list"], [], undefined, "odOrderSkeletonList");
    DomHelper.appendNode(orderScreen, "section", ["od-order-list"], [], undefined, "odWebshopOrderList");
    const orderFooter = DomHelper.appendNode(orderScreen, "section", ["od-order-footer"]);
    renderOrderFooter(orderFooter);
}
function renderOrderHeader(orderHeader) {
    DomHelper.appendNode(orderHeader, "h1", [], [], "Bestellübersicht");
}
function renderOrderFooter(orderFooter) {
    const loadMoreButton = DomHelper.appendNode(orderFooter, "button", ["load-btn"], [{ attr: "data-last-data", value: `` }], undefined, "odOrderLoadMore");
    DomHelper.appendNode(loadMoreButton, "span", ["od-btn-spinner"], [{ attr: "aria-hidden", value: "true" }]);
    DomHelper.appendNode(loadMoreButton, "span", ["od-btn-label"], [], "Weitere 90 Tage laden");
    loadMoreButton.addEventListener("click", () => {
        setButtonLoading(true);
        renderOrderData().finally(() => {
            console.log("renderOrderData.finally() => loaded");
            setButtonLoading(false);
        });
    });
}
function renderOrderCardNoItems(orderList, order) {
    const orderCard = DomHelper.appendNode(orderList, "article", ["od-order-card"]);
    const orderHeader = DomHelper.appendNode(orderCard, "section", ["od-order-card-header"]);
    const formattedDate = formateTimeStamp(order.orderDate);
    DomHelper.appendNode(orderHeader, "h2", ["od-order-date"], [], `Bestelldatum: ${formattedDate}`);
    DomHelper.appendNode(orderHeader, "p", ["od-order-meta"], [], `Fehlerhafte Bestellung`);
    const orderNoItem = DomHelper.appendNode(orderCard, 'section', ['od-order-no-item']);
    DomHelper.appendNode(orderNoItem, "p", ["od-highlight-error"], [], "In der Bestellung konnten keine Artikel geladen werden");
}
function renderOrderCard(orderList, order, prepend = false) {
    let orderCard;
    if (prepend) {
        orderCard = DomHelper.appendNodeFirstChild(orderList, "article", ["od-order-card"]);
    }
    else {
        orderCard = DomHelper.appendNode(orderList, "article", ["od-order-card"]);
    }
    const orderHeader = DomHelper.appendNode(orderCard, "section", ["od-order-card-header"]);
    const orderTable = DomHelper.appendNode(orderCard, "table", ["od-order-card-table"]);
    const formattedDate = formateTimeStamp(order.orderDate);
    DomHelper.appendNode(orderHeader, "h2", ["od-order-date"], [], `Bestelldatum: ${formattedDate}`);
    DomHelper.appendNode(orderHeader, "p", ["od-order-meta"], [], `${order.items.meta.totalNumber} Artikel`);
    renderOrderCardTable(orderTable, order);
}
function appendOrderToHistory(orderId) {
    return __awaiter(this, void 0, void 0, function* () {
        const orderList = document.getElementById("odWebshopOrderList");
        let user = store.shopUserId;
        let bearerToken = store.bearerToken;
        getShopBackendData("", `/orders/${user}/${orderId}`, "GET", "application/json", bearerToken, function (response) {
            if (response.target.status !== 200) {
                DomHelper.showMessage({
                    appcn: "",
                    appdn: "",
                    duration: 5000,
                    header: "Error",
                    icon: "fa-cart-circle-xmark",
                    message: "Es ist etwas schief gelaufen beim Laden der Bestellinformationen",
                    type: 'error',
                    version: ""
                }, null, bearerToken);
                return;
            }
            const responseRaw = JSON.parse(response.target.response);
            const orderResponse = responseRaw;
            if (!orderResponse.items || !orderResponse.items.meta || orderResponse.items.meta.totalNumber === 0) {
                renderOrderCardNoItems(orderList, orderResponse);
            }
            else {
                renderOrderCard(orderList, orderResponse, true);
            }
        });
    });
}
function renderOrderCardTable(orderTable, order) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    const thead = DomHelper.appendNode(orderTable, "thead", []);
    const trHead = DomHelper.appendNode(thead, "tr", []);
    DomHelper.appendNode(trHead, "th", [], [], "Artikel");
    DomHelper.appendNode(trHead, "th", [], [], "Nutzer");
    DomHelper.appendNode(trHead, "th", [], [], "Lieferadresse");
    DomHelper.appendNode(trHead, "th", [], [], "Kostenstelle");
    DomHelper.appendNode(trHead, "th", [], [], "Status");
    const tBody = DomHelper.appendNode(orderTable, "tbody", []);
    const items = order.items.objectList || [];
    for (const item of items) {
        const tr = DomHelper.appendNode(tBody, "tr", []);
        const tdArtikel = DomHelper.appendNode(tr, "td", []);
        DomHelper.appendNode(tdArtikel, "div", ["product-name"], [], ((_a = item.product) === null || _a === void 0 ? void 0 : _a.name) || "-");
        DomHelper.appendNode(tdArtikel, "span", ["product-type"], [], ((_b = item.ciType) === null || _b === void 0 ? void 0 : _b.name) || "-");
        const userName = `${((_c = item.user) === null || _c === void 0 ? void 0 : _c.firstName) || ""} ${((_d = item.user) === null || _d === void 0 ? void 0 : _d.lastName) || ""}`.trim();
        DomHelper.appendNode(tr, "td", [], [], userName);
        const tdAdresse = DomHelper.appendNode(tr, "td", []);
        const addressBox = DomHelper.appendNode(tdAdresse, "div", ["address-box"]);
        const companyName = ((_f = (_e = item.location) === null || _e === void 0 ? void 0 : _e.company) === null || _f === void 0 ? void 0 : _f.title) || "-";
        DomHelper.appendNode(addressBox, "span", ["address-company"], [], companyName);
        DomHelper.appendNode(addressBox, "br", []);
        const street = `${((_g = item.location) === null || _g === void 0 ? void 0 : _g.street) || ""} ${((_h = item.location) === null || _h === void 0 ? void 0 : _h.street_number) || ""}`.trim();
        addressBox.appendChild(document.createTextNode(street));
        DomHelper.appendNode(addressBox, "br", []);
        const city = `${((_j = item.location) === null || _j === void 0 ? void 0 : _j.postalCode) || ""} ${((_k = item.location) === null || _k === void 0 ? void 0 : _k.city) || ""}`.trim();
        addressBox.appendChild(document.createTextNode(city));
        DomHelper.appendNode(addressBox, "br", []);
        const room = `Geb: ${((_l = item.location) === null || _l === void 0 ? void 0 : _l.building) || "-"} | Raum: ${((_m = item.location) === null || _m === void 0 ? void 0 : _m.room) || "-"}`;
        addressBox.appendChild(document.createTextNode(room));
        DomHelper.appendNode(tr, "td", [], [], item.costCenter);
        let resolvedState = resolveState(item.state);
        const tdStatus = DomHelper.appendNode(tr, "td", []);
        DomHelper.appendNode(tdStatus, "span", ["status-badge", `status-badge--${resolvedState.toLowerCase()}`], [], resolvedState || "-");
    }
}
function renderNotFoundCard(orderList, dateFrom, dateTo) {
    const cardNotFound = DomHelper.appendNode(orderList, 'article', ['od-card-not-found']);
    DomHelper.appendNode(cardNotFound, 'h2', [], [], 'Keine Bestellungen gefunden');
    DomHelper.appendNode(cardNotFound, 'p', [], [], `Im gewählten Zeitraum von 
            <span class="od-highlight-dates">${formateTimeStampToDateOnly(dateTo)} bis ${formateTimeStampToDateOnly(dateFrom)}</span> liegen keine Bestellungen vor`);
    DomHelper.appendNode(cardNotFound, 'p', [], [], "Es können jedoch weitere Daten aus der Vergangenheit nachgeladen werden");
}
function resolveState(state) {
    switch (state) {
        case 'New':
            return 'Eingegangen';
        case 'Ordered':
            return 'Bestellt';
        case 'z99_konfiguriert':
            return 'Eingegangen';
        case 'Delivered':
            return 'Geliefert';
        case 'Active':
            return 'Aktiv';
        case 'z99_storniert':
            return 'Storniert';
        default:
            return state;
    }
}
function formateTimeStamp(timeStamp) {
    const date = new Date(timeStamp);
    return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
}
function formateTimeStampToDateOnly(timeStamp) {
    const date = new Date(timeStamp);
    return new Intl.DateTimeFormat('de-DE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);
}
function disableOrderHistory(e) {
    e.preventDefault();
    const orderScreen = document.getElementById("odRecentOrderListPane");
    const odWebshopPane = document.getElementById("odWebshopPane");
    odWebshopPane.classList.remove('disabled');
    orderScreen.classList.add('disabled');
    const productSearchbar = document.getElementById('odProductSearchbar');
    const orderSearchbar = document.getElementById('odOrderSearchbar');
    productSearchbar.classList.remove('disabled');
    orderSearchbar.classList.add('disabled');
    refreshProducts = true;
}
function injectWebshopNav() {
    const navBar = document.getElementById('appNavigation');
    if (!navBar) {
        return;
    }
    navBar.classList.remove("invisible");
    const orderLinkNode = DomHelper.appendNodeFirstChild(navBar, "a", ["od-nav-item", "permanent"], [{ attr: "href", value: "" }], "Bestellungen");
    const shopLinkNode = DomHelper.appendNodeFirstChild(navBar, "a", ["od-nav-item", "permanent"], [{ attr: "href", value: "" }], "Produkte");
    orderLinkNode.addEventListener("click", (e) => enableOrderHistory(e));
    shopLinkNode.addEventListener("click", (e) => disableOrderHistory(e));
}
function createButtonRefresh(injectNode, userid, bearerToken, userPreferences) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2', 'ms-1',], [{
            attr: 'id',
            value: ''
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-refresh', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [{ attr: 'data-mode', value: 'products' }], 'aktualisieren');
    buttonNode.addEventListener('click', (event) => refreshWebshop(bearerToken, userid, userPreferences, buttonNode));
}
function addSkeletonCards(parentElement, username, bearerToken, userPreferences, amount) {
    productListRender(parentElement, -1, bearerToken, userPreferences, null, true);
}
function removeSkeletonCards(parentElement) {
    const nodeSkeleton = parentElement.querySelector('.skeleton');
    if (nodeSkeleton)
        nodeSkeleton.remove();
}
function handleCartItemSave(parentElement, userid, bearerToken) {
    if (DEBUG)
        console.log("--> handleCartItemSave");
}
function handleCartItemEdit(parentElement, userid, bearerToken) {
    if (DEBUG)
        console.log("--> handleCartItemEdit");
}
function handleCartItemDelete(parentElement, cartItem, userid, bearerToken) {
    if (DEBUG)
        console.log("--> handlCartItemDelete");
    getShopBackendData("", `/shoppingcart/${userid}/items/${cartItem.id}`, "DELETE", "application/json", bearerToken, function (response) {
        if (response.target.status === 204) {
            removeItemWithAnimation(parentElement);
        }
    });
}
function removeItemWithAnimation(element) {
    element.classList.add('shrinking');
    element.addEventListener('animationend', () => {
        element.remove();
        updateCartSummary();
    });
}
function updateCartSummary() {
    const sumNode = document.getElementById('cart-sum');
    const sumRentNode = document.getElementById('cart-sum-rent');
    const sumRentNode12 = document.getElementById('cart-sum-rent-12');
    const amountNode = document.getElementById('od-shop-cart-counter');
    const checkoutButton = document.getElementById('cart-checkout-button');
    const items = document.querySelectorAll('.od-cart-item');
    let sum = 0.0;
    let sum_rent = 0.0;
    let itemCount = 0;
    for (const item of items) {
        itemCount++;
        const priceType = item.getAttribute('price-type');
        const price = Number(item.getAttribute('price'));
        const amount = Number(item.getAttribute('amount'));
        if (price && priceType) {
            if (priceType === "Kauf") {
                sum += price * amount;
            }
            else {
                sum_rent += price * amount;
            }
        }
    }
    if (sumNode)
        sumNode.innerHTML = Util.number2money(sum, 'EUR');
    if (sumRentNode)
        sumRentNode.innerHTML = Util.number2money(sum_rent, 'EUR');
    if (sumRentNode12)
        sumRentNode12.innerHTML = Util.number2money(sum_rent * 12, 'EUR');
    if (amountNode)
        amountNode.innerText = itemCount + "";
    if (checkoutButton)
        checkoutButton.disabled = itemCount === 0;
}
function getTotalPriceOfProduct(product, cart) {
    let optionsPrice = 0;
    if (cart.options) {
        for (const option of cart.options) {
            optionsPrice += option.amount * option.price;
        }
    }
    return product.price + optionsPrice;
}
function renderCartItem(parentNode, product, cartItem, userid, bearerToken, insertBeforeParent = false) {
    let liNode;
    const totalProductPrice = getTotalPriceOfProduct(product, cartItem);
    const attributes = [
        { attr: 'otid', value: `${cartItem.id}` },
        { attr: 'amount', value: `${cartItem.amount}` },
        { attr: 'price-type', value: `${product.priceType}` },
        { attr: 'price', value: `${totalProductPrice}` }
    ];
    if (insertBeforeParent) {
        liNode = DomHelper.appendNodeBefore(parentNode, 'div', ['od-cart-item'], attributes);
    }
    else {
        liNode = DomHelper.appendNode(parentNode, 'div', ['od-cart-item'], attributes);
    }
    DomHelper.appendNode(liNode, 'div', ['od-product-title'], [], product.name);
    DomHelper.appendNode(liNode, 'div', ['od-product-amount'], [], `${cartItem.amount}`);
    DomHelper.appendNode(liNode, 'div', ['od-product-unitprice'], [], Util.number2money(Number(totalProductPrice), 'EUR'));
    DomHelper.appendNode(liNode, 'div', ['od-product-price'], [{
            attr: 'price',
            value: totalProductPrice.toString()
        }], Util.number2money(Number(totalProductPrice) * Number(cartItem.amount), 'EUR'));
    DomHelper.appendNode(liNode, 'div', ['od-product-price-type'], [], product.priceType);
    const ccNode = DomHelper.appendNode(liNode, 'div', ['od-product-costcentre'], []);
    const ccIconNode = DomHelper.appendNode(ccNode, 'i', ['fa-light', 'fa-hand-holding-dollar'], []);
    DomHelper.addToolTip(ccIconNode, 'Kostenstelle');
    DomHelper.appendNode(ccNode, 'span', [], [], cartItem.costcentre.label + "");
    const userNode = DomHelper.appendNode(liNode, 'div', ['od-product-enduser'], []);
    const userIconNode = DomHelper.appendNode(userNode, 'i', ['fa-light', 'fa-user-tag'], []);
    DomHelper.addToolTip(userIconNode, 'Endbenutzer_in');
    const domIDUserName = Util.generateRandomDomId();
    DomHelper.appendNode(userNode, 'span', [], [], cartItem.end_user_id.label, domIDUserName);
    DomHelper.appendNode(liNode, 'div', ['od-product-description'], [], cartItem.remark);
    const actionArea = DomHelper.appendNode(liNode, 'div', ['od-cart-actions'], []);
    const deleteArea = DomHelper.appendNode(actionArea, 'div', [], []);
    const deleteAreaIcon = DomHelper.appendNode(deleteArea, 'i', ['fa-light', 'fa-trash'], []);
    deleteAreaIcon.addEventListener('click', event => {
        handleCartItemDelete(liNode, cartItem, userid, bearerToken);
    });
    return liNode;
}
function mapDataToItemId(itemId) {
    console.log("-->  mapDataToItemId");
    if (itemId && itemId.length == 0) {
        console.log("Too short");
        return;
    }
    const shop_cart = document.getElementById('od-cart-holder');
    if (shop_cart) {
        const children = shop_cart.children;
        for (const node of children) {
            if (!node.getAttribute("otid")) {
                continue;
            }
            if (itemId == node.getAttribute("otid")) {
                removeItemWithAnimation(node);
                break;
            }
        }
        console.log("end of childrenns");
    }
    else {
        console.log("not found");
    }
}
function toggleCart() {
    const paneNode = document.getElementById('odWebshopPane');
    if (paneNode)
        paneNode.classList.toggle('showcart');
}
function cartRender(parentElement, userid, bearerToken, userPreferences, response, allProductList, skeleton = false) {
    if (DEBUG)
        console.log("--> cartRender", response);
    const additionalClassList = [];
    if (skeleton)
        additionalClassList.push('skeleton');
    const wrapNode = DomHelper.appendNode(parentElement, 'aside', [...additionalClassList, 'od-shop-cart'], [], undefined, 'od-cart-holder');
    const headerNode = DomHelper.appendNode(wrapNode, 'div', ['od-shop-cart-header'], []);
    const headerIconNode = DomHelper.appendNode(headerNode, 'i', ['fa-light', 'fa-shopping-cart'], []);
    headerNode.addEventListener('click', event => {
        toggleCart();
    });
    DomHelper.appendNode(headerNode, 'h2', [...additionalClassList], [], 'Warenkorb', 'od-shop-cart-headline');
    const countNode = DomHelper.appendNode(headerNode, 'div', [], [], '0', 'od-shop-cart-counter');
    const cartList = response.items;
    let totalPrice = 0;
    let totalPriceRent = 0;
    let itemCount = 0;
    for (const cartItem of cartList) {
        const product = allProductList.find((item) => Number(item.id) === Number(cartItem.product_id.id));
        if (product) {
            renderCartItem(wrapNode, product, cartItem, userid, bearerToken);
            let totalProductPrice = getTotalPriceOfProduct(product, cartItem);
            if (product.priceType === "Kauf")
                totalPrice += Number(totalProductPrice) * Number(cartItem.amount);
            else
                totalPriceRent += Number(totalProductPrice) * Number(cartItem.amount);
            itemCount++;
        }
    }
    const summaryNode = DomHelper.appendNode(wrapNode, 'div', ['od-cart-summary'], [], '', 'od-cart-summary');
    countNode.innerText = itemCount + "";
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-label'], [], 'Gesamtpreis');
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-pricetype-rent'], [], "Miete/Leasing pro Monat");
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-price-rent'], [], Util.number2money(totalPriceRent, 'EUR'), 'cart-sum-rent');
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-pricetype-rent-12'], [], "Miete/Leasing pro Jahr");
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-price-rent-12'], [], Util.number2money(totalPriceRent * 12, 'EUR'), 'cart-sum-rent-12');
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-pricetype-buy'], [], "Kauf");
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-price'], [], Util.number2money(totalPrice, 'EUR'), 'cart-sum');
    DomHelper.appendNode(summaryNode, 'div', ['od-sum-footer'], [], 'Alle Preisangaben sind Nettopreise zzgl. MwSt.');
    const checkoutNode = DomHelper.appendNode(wrapNode, 'div', ['od-cart-checkout'], [], '', 'od-cart-checkout');
    const buttonNode = DomHelper.appendNode(checkoutNode, 'button', ['btn', 'btn-primary', 'mt-4'], [{
            attr: 'id',
            value: 'cart-checkout-button'
        }]);
    buttonNode.disabled = cartList.length === 0;
    const checkoutIcon = DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-cart-shopping'], []);
    const checkoutText = DomHelper.appendNode(buttonNode, 'span', [], [], 'Kostenpflichtig bestellen.');
    const refreshActionNode = DomHelper.appendNode(checkoutNode, 'button', ['btn', 'btn-secondary', 'mt-4'], [{
            attr: 'id',
            value: 'cart-refresh-button'
        }]);
    const refreshIcon = DomHelper.appendNode(refreshActionNode, 'i', ['fa-light', 'fa-cart-circle-xmark'], []);
    const refreshText = DomHelper.appendNode(refreshActionNode, 'span', [], [], 'Warenkorb löschen');
    buttonNode.addEventListener('click', event => {
        console.log("Checkout clicked");
        buttonNode.disabled = true;
        checkoutIcon.classList.remove('fa-cart-shopping');
        checkoutIcon.classList.add('fa-spinner-scale');
        checkoutIcon.classList.add('fa-spin');
        checkoutText.innerText = "Bestellung wird abgeschlossen...";
        sendShopBackendData('', `/shoppingcart/${userid}/checkout`, 'POST', 'application/json', bearerToken, {}, function (response) {
            const checkoutResponse = JSON.parse(response.target.response);
            if (!Util.isResponseData(checkoutResponse)) {
                DomHelper.showMessage({
                    appcn: "",
                    appdn: "",
                    duration: 5000,
                    header: "Error",
                    icon: "fa-cart-circle-xmark",
                    message: checkoutResponse.error,
                    type: 'error',
                    version: ""
                }, null, bearerToken);
                buttonNode.disabled = false;
                checkoutIcon.classList.add('fa-cart-shopping');
                checkoutIcon.classList.remove('fa-spinner-scale');
                checkoutIcon.classList.remove('fa-spin');
                checkoutText.innerText = "Kostenpflichtig bestellen";
                return;
            }
            switch (checkoutResponse.code) {
                case 201:
                    refreshWebshop(bearerToken, userid, userPreferences, buttonNode);
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Info",
                        icon: "fa-cart-circle-check",
                        message: `Die Bestellung wurde erfolgreich abgeschlossen.`,
                        type: 'info',
                        version: ""
                    }, null, bearerToken);
                    const rsp = checkoutResponse.body.success;
                    appendOrderToHistory(rsp.shoppingcart_id);
                    break;
                case 207:
                    const success = checkoutResponse.body.success;
                    const error = checkoutResponse.body.error;
                    for (const item of success.items) {
                        mapDataToItemId(item.item);
                        DomHelper.showMessage({
                            appcn: "",
                            appdn: "",
                            duration: 5000,
                            header: "Info",
                            icon: "fa-cart-circle-check",
                            message: `CMDB mit der Id ${item.cmdb_id} wurde angelegt`,
                            type: 'info',
                            version: ""
                        }, null, bearerToken);
                    }
                    showMessageForErrorItems(error, bearerToken);
                    break;
                case 400:
                    showMessageForErrorItems(checkoutResponse.body.error, bearerToken);
                    break;
                default:
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Error",
                        icon: "fa-cart-circle-xmark",
                        message: "Ein unerwarteter Fehler ist passiert",
                        type: 'error',
                        version: ""
                    }, null, bearerToken);
            }
            buttonNode.disabled = false;
            checkoutIcon.classList.add('fa-cart-shopping');
            checkoutIcon.classList.remove('fa-spinner-scale');
            checkoutIcon.classList.remove('fa-spin');
            checkoutText.innerText = "Kostenpflichtig bestellen";
        });
    });
    refreshActionNode.addEventListener('click', event => {
        console.log('Refresh clicked');
        refreshIcon.classList.remove('fa-cart-circle-xmark');
        refreshIcon.classList.add('fa-spinner-scale');
        refreshIcon.classList.add('fa-spin');
        refreshText.innerText = 'Warenkorb wird gelöscht...';
        sendShopBackendData('', `/shoppingcart/${userid}/refresh`, 'POST', 'application/json', bearerToken, {}, function (response) {
            const statusCode = response.target.status;
            const refreshResponse = JSON.parse(response.target.response);
            console.log(JSON.stringify(refreshResponse));
            switch (statusCode) {
                case 201:
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Info",
                        icon: "fa-badge-check",
                        message: 'Der Warenkorb wurde erfolgreich gelöscht',
                        type: 'info',
                        version: ""
                    }, null, bearerToken);
                    refreshWebshop(bearerToken, userid, userPreferences, buttonNode);
                    break;
                case 404:
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Error",
                        icon: "fa-circle-exclamation",
                        message: 'Der Warenkorb ist leer',
                        type: 'error',
                        version: ""
                    }, null, bearerToken);
                    break;
                default:
                    DomHelper.showMessage({
                        appcn: "",
                        appdn: "",
                        duration: 5000,
                        header: "Error",
                        icon: "fa-circle-exclamation",
                        message: `Ein unerwarteter Fehler ist aufgetreten. (${statusCode})`,
                        type: 'error',
                        version: ""
                    }, null, bearerToken);
            }
            refreshIcon.classList.add('fa-cart-circle-xmark');
            refreshIcon.classList.remove('fa-spinner-scale');
            refreshIcon.classList.remove('fa-spin');
            refreshText.innerText = "Warenkorb löschen";
        });
    });
}
function showMessageForErrorItems(errorList, bearerToken) {
    errorList.forEach((error) => {
        console.log("Error: " + JSON.stringify(error));
        DomHelper.showMessage({
            appcn: "",
            appdn: "",
            duration: 5000,
            header: "Error",
            icon: "fa-cart-circle-xmark",
            message: error.errorList.join(' & '),
            type: 'error',
            version: ""
        }, null, bearerToken);
    });
}
function updateProductPrice(cardNode) {
    const optionNode = cardNode.querySelector('.od-product-options');
    let price = 0;
    if (optionNode) {
        const optionList = optionNode.querySelectorAll('.od-product-option');
        for (const opt of optionList) {
            price += Number(opt.getAttribute('price'));
        }
        const priceNode = cardNode.querySelector('.od-product-price');
        if (priceNode) {
            priceNode.innerText = Util.number2money(price + Number(priceNode.getAttribute('price')), 'EUR');
        }
    }
}
function renderOption(cardNode, optionListNode, opt) {
    const optionNode = DomHelper.appendNode(optionListNode, 'div', ['od-product-option'], [
        { attr: 'item-price', value: opt.price.toString() },
        { attr: 'item-amount', value: "0" },
        { attr: 'name', value: opt.name },
        { attr: 'option-id', value: opt.id },
        { attr: 'price', value: (opt.price * 0).toString() },
    ]);
    DomHelper.appendNode(optionNode, 'div', [], [], opt.name);
    if (Number(opt.maxAmount) > 1) {
        DomHelper.appendIntWidget(optionNode, opt.id, 'Menge', 0, `amount-${opt.id}`, (amount) => {
            optionNode.setAttribute('item-amount', amount.toString());
            optionNode.setAttribute('price', (amount * opt.price).toString());
            updateProductPrice(cardNode);
        });
    }
    else if (Number(opt.maxAmount) === 1) {
        DomHelper.appendCheckboxWidget(optionNode, opt.id, 'Menge', false, `amount-${opt.id}`, (activeState) => {
            let amount = activeState ? 1 : 0;
            optionNode.setAttribute('item-amount', amount.toString());
            optionNode.setAttribute('price', (amount * opt.price).toString());
            updateProductPrice(cardNode);
        });
    }
    DomHelper.appendNode(optionNode, 'div', ['od-price'], [], Util.number2money(opt.price, 'EUR'));
}
function getOptionsFromProductCard(cardOrderNode) {
    const optionsNode = cardOrderNode.querySelector('.od-product-options');
    let optionlist = [];
    if (optionsNode) {
        const options = optionsNode.querySelectorAll('.od-product-option[item-amount]:not([item-amount="0"])');
        for (const item of options) {
            const option = {
                option_id: Number(item.getAttribute('option-id')),
                amount: Number(item.getAttribute('item-amount')),
                name: item.getAttribute('name'),
                price: Number(item.getAttribute('price')),
            };
            optionlist.push(option);
        }
    }
    return optionlist;
}
function add2Cart(userid, bearerToken, items, productLabel, allProductList) {
    sendShopBackendData('', `/shoppingcart/${userid}/items`, 'POST', 'application/json', bearerToken, items, function (response) {
        const responseCartAdd = JSON.parse(response.target.response);
        const newCartItem = responseCartAdd.item;
        const cardSummary = document.getElementById('od-cart-summary');
        const product = allProductList.find((item) => Number(item.id) === Number(newCartItem.product_id.id));
        if (cardSummary && product) {
            renderCartItem(cardSummary, product, newCartItem, userid, bearerToken, true);
            updateCartSummary();
        }
        DomHelper.showMessage({
            appcn: "",
            appdn: "",
            duration: 5000,
            header: "Info",
            icon: "fa-cart-circle-check",
            message: `${productLabel} wurde in den Warenkorb gelegt`,
            type: 'info',
            version: ""
        }, null, bearerToken);
    });
}
function renderProductDetail(cardNode, product, userid, bearerToken, allProductList) {
    cardNode.classList.add('rudi-row-span-2');
    cardNode.classList.add('rudi-col-span-2');
    const cardMainNode = cardNode.querySelector('.od-product-main');
    const inputNodeList = [];
    function setInputFieldValue(inputNode, value, label, selectNode) {
        inputNode.innerHTML = label;
        inputNode.setAttribute('value', value);
        selectNode.classList.add('disabled');
        const fgNode = DomHelper.getFirstParentWithClass(inputNode, 'form-group');
        if (fgNode) {
            const iconNode = fgNode.querySelector('.fa-light');
            if (iconNode) {
                iconNode.classList.remove('fa-search');
                iconNode.classList.add('fa-check');
                Util.disableValidationErrorMessage(inputNode);
            }
        }
    }
    function updateInputField(event, inputNode, selectNode) {
        event.preventDefault();
        const clickNode = event.target;
        if (clickNode) {
            const value = clickNode.getAttribute('value');
            if (value) {
                console.log('click registered', value, clickNode.innerHTML);
                setInputFieldValue(inputNode, value, clickNode.innerHTML, selectNode);
            }
        }
    }
    function filterAddressQueryResult(query) {
        const filterstring = query.replace(store.lastSearchString, "").trim().toLowerCase();
        return store.addressQueryResult.filter((item) => item.title.toLowerCase().includes(filterstring)
            || item.street.toLowerCase().includes(filterstring.toLowerCase())
            || item.city.toLowerCase().includes(filterstring.toLowerCase())
            || item.street_number.toLowerCase().includes(filterstring.toLowerCase())
            || item.postal_code.toLowerCase().includes(filterstring.toLowerCase())
            || item.company.toLowerCase().includes(filterstring.toLowerCase()));
    }
    function renderResults(selectNode, results, getLabel, handleOptionClick, query) {
        selectNode.classList.remove('disabled');
        const sortedResults = Util.sortOtNameKeyObjectByLabel(results, getLabel);
        while (selectNode.firstChild) {
            selectNode.removeChild(selectNode.firstChild);
        }
        for (let cc of sortedResults) {
            if (!store.nameKeyOtObject.has(cc.id)) {
                store.nameKeyOtObject.set(cc.id, getLabel(cc));
            }
            DomHelper.appendOption(selectNode, cc.id + "", getLabel(cc), false, handleOptionClick);
        }
        if (query)
            store.lastSearchString = query.trim();
    }
    function getLabelOtAdr(o) {
        const adr = o;
        return `${adr.title} | ${adr.company} | ${adr.city} | ${adr.street} ${adr.street_number}`;
    }
    function validateForm(inputList) {
        let isFormValid = true;
        for (const input of inputList) {
            let stringVal = Util.getValueOfDivInput(input.node);
            let isInputValid = true;
            let message = "";
            if (stringVal) {
                stringVal = stringVal.replace(/<br>/g, '');
                console.log("Removed Break Tag, New String: " + stringVal);
            }
            if (input.required && (!stringVal || stringVal.length === 0)) {
                message = input.errormessage ? input.errormessage : "Bitte füllen Sie dieses Feld aus.";
                isInputValid = false;
            }
            else if (stringVal && input.pattern) {
                try {
                    const pattern = new RegExp(input.pattern);
                    const patternMatch = pattern.test(stringVal);
                    if (DEBUG)
                        console.log("Patternmatch result", patternMatch);
                    isInputValid = patternMatch;
                    if (!isInputValid) {
                        message = input.errormessage ? input.errormessage : "Die Eingabe entspricht nicht dem geforderten Format.";
                    }
                }
                catch (e) {
                    console.log("Error on converting RegEx Pattern", input.pattern);
                }
            }
            if (!isInputValid) {
                Util.enableValidationErrorMessage(input.node, message);
                isFormValid = false;
            }
            else {
                Util.disableValidationErrorMessage(input.node);
            }
        }
        return isFormValid;
    }
    function renderOrderForm() {
        var _a, _b;
        let enduserLabel = '';
        let enduserValue = -1;
        if (store.lastOrder.end_user_id) {
            enduserValue = store.lastOrder.end_user_id;
            enduserLabel = store.nameKeyOtObject.get(store.lastOrder.end_user_id) ? store.nameKeyOtObject.get(store.lastOrder.end_user_id) : "";
        }
        const orderDetailNode = cardNode.querySelector('.od-order-detail');
        function storeOtObjects(list, getLabel, selectNode, handleOptionClick) {
            for (let otNameKeyObj of list) {
                if (otNameKeyObj.id) {
                    if (!store.nameKeyOtObject.has(otNameKeyObj.id)) {
                        store.nameKeyOtObject.set(otNameKeyObj.id, getLabel(otNameKeyObj));
                    }
                }
            }
        }
        if (orderDetailNode) {
            orderDetailNode.classList.remove('disabled');
            const amountWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper', 'od-inline']);
            DomHelper.appendNode(amountWrapperNode, 'h2', [], [], 'Anzahl');
            const amountNode = DomHelper.appendIntWidget(amountWrapperNode, 'amount', 'Menge', 1, `amount-${product.id}`, (amount) => {
            });
            const enduserWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(enduserWrapperNode, 'h2', [], [], 'Für wen wird bestellt?');
            const hiddenLoginName = DomHelper.appendNode(enduserWrapperNode, 'div', ['disabled'], [{ attr: 'type', value: 'text' }, { attr: 'value', value: store.phoneStore.enduser }], undefined, `userloginname-${product.id}`);
            const enduserNode = DomHelper.appendFilteringSelect(enduserWrapperNode, 'end_user_id', enduserLabel, enduserValue + '', `enduserid-${product.id}`, (enduser, selectNode, inputNode) => {
                getShopBackendData('', `/search/users/?search=${enduser}*`, 'GET', 'application/json', bearerToken, (response) => {
                    console.log("got response", response.target.response, response.target.status);
                    if (response.target.status === 200) {
                        const results = JSON.parse(response.target.response);
                        function handleOptionClick(event) {
                            updateInputField(event, inputNode, selectNode);
                        }
                        function getLabel(o) {
                            const user = o;
                            return `${user.firstName} ${user.lastName}`;
                        }
                        if (results.objectList.length == 1) {
                            const o = results.objectList[0];
                            setInputFieldValue(inputNode, o.id + '', getLabel(o), selectNode);
                            hiddenLoginName.setAttribute('value', o.username);
                            DomHelper.setFocus(orderDetailNode, '[name=costcenter-input]');
                        }
                        else {
                            renderResults(selectNode, results.objectList, getLabel, handleOptionClick);
                        }
                        storeOtObjects(results.objectList, getLabel, selectNode, handleOptionClick);
                    }
                });
            }, 4);
            const costcenterWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(costcenterWrapperNode, 'h2', [], [], 'Für welche Kostenstelle wird bestellt?');
            let ccLabel = '';
            let ccValue = -1;
            if (store.lastOrder.costcenter_id) {
                ccValue = store.lastOrder.costcenter_id;
                ccLabel = store.nameKeyOtObject.get(store.lastOrder.costcenter_id) ? store.nameKeyOtObject.get(store.lastOrder.costcenter_id) : "";
            }
            const costcenterNode = DomHelper.appendFilteringSelect(costcenterWrapperNode, 'costcenter', ccLabel, ccValue + '', `costcenter-${product.id}`, (enduser, selectNode, inputNode) => {
                getShopBackendData('', `/search/costcenters/?search=${enduser}`, 'GET', 'application/json', bearerToken, (response) => {
                    var _a;
                    console.log("got response", response.target.response);
                    const results = JSON.parse(response.target.response);
                    const objectList = results.objectList;
                    function handleOptionClick(event) {
                        updateInputField(event, inputNode, selectNode);
                    }
                    function getLabel(o) {
                        const costcenter = o;
                        return `${costcenter.internalNumber} | ${costcenter.gb} | ${costcenter.title}`;
                    }
                    if (objectList.length == 1) {
                        const o = objectList[0];
                        setInputFieldValue(inputNode, o.id + '', getLabel(o), selectNode);
                        if (((_a = product.ciType) === null || _a === void 0 ? void 0 : _a.name) != "Smartphone") {
                            DomHelper.setFocus(orderDetailNode, '[name=techlocationadr-input]');
                        }
                        else {
                            DomHelper.setFocus(orderDetailNode, '[name=phonenumber-input]');
                        }
                    }
                    else {
                        renderResults(selectNode, objectList, getLabel, handleOptionClick);
                    }
                    storeOtObjects(objectList, getLabel, selectNode, handleOptionClick);
                });
            });
            const mobileWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(mobileWrapperNode, 'h2', [], [], 'Für welche Mobilfunknummer wird bestellt?');
            let storedContractId = extractContractNumberFromRemarkCache(store.lastOrder.remark);
            let phoneNumberString = extractPhoneNumberFromRemarkCache(store.lastOrder.remark);
            const contractValue = DomHelper.appendNode(mobileWrapperNode, 'div', ["disabled"], [{ attr: 'type', value: 'text' }, { attr: 'value', value: storedContractId }], undefined, `contractnumber-${product.id}`);
            const hiddenPhoneNode = DomHelper.appendNode(mobileWrapperNode, 'div', ["disabled"], [{ attr: 'type', value: 'text' }, { attr: 'value', value: phoneNumberString }], undefined, `phonenumber-${product.id}`);
            const hiddenLoginNameNode = DomHelper.appendNode(mobileWrapperNode, 'div', ["disabled"], [{ attr: 'type', value: 'text' }, { attr: 'value', value: store.phoneStore.phoneuser }], undefined, `loginname-${product.id}`);
            if (((_a = product.ciType) === null || _a === void 0 ? void 0 : _a.name) != "Smartphone") {
                mobileWrapperNode.classList.add('disabled');
            }
            let phoneLabel = '';
            let phoneValue = -1;
            if (store.lastOrder.phone_number_id) {
                phoneValue = store.lastOrder.phone_number_id;
                phoneLabel = store.nameKeyOtObject.get(store.lastOrder.phone_number_id) ? store.nameKeyOtObject.get(store.lastOrder.phone_number_id) : "";
            }
            const phoneNumberNode = DomHelper.appendFilteringSelect(mobileWrapperNode, 'phonenumber', phoneLabel, phoneValue, `phonenumber-${product.id}`, (query, selectNode, inputNode) => {
                let searchstring = "";
                if (!query.startsWith('*')) {
                    query = `*${query}`;
                }
                if (!query.endsWith('*')) {
                    query = `${query}*`;
                }
                searchstring = query;
                if (searchstring.length < 5)
                    return;
                getShopBackendData('', `/search/mobiles/?search=${searchstring}`, 'GET', 'application/json', bearerToken, (response) => {
                    console.log("got response", response.target.response);
                    const results = JSON.parse(response.target.response);
                    const objectList = results.objectList;
                    function handleOptionClick(event) {
                        updateInputField(event, inputNode, selectNode);
                    }
                    function getLabel(o) {
                        const mobile = o;
                        return `${mobile.number} | ${mobile.validTo ? Util.isoString2DateString(mobile.validTo) : "-/-"} | ${mobile.firstName} ${mobile.lastName}`;
                    }
                    if (objectList.length == 1) {
                        const o = objectList[0];
                        setInputFieldValue(inputNode, o.id + '', getLabel(o), selectNode);
                        if (objectList[0].contractNumber)
                            contractValue.setAttribute('value', objectList[0].contractNumber);
                        if (objectList[0].number)
                            hiddenPhoneNode.setAttribute('value', objectList[0].number);
                        if (objectList[0].loginName)
                            hiddenLoginNameNode.setAttribute('value', objectList[0].loginName);
                        DomHelper.setFocus(orderDetailNode, '[name=techlocationadr-input]');
                    }
                    else {
                        renderResults(selectNode, objectList, getLabel, handleOptionClick);
                    }
                    storeOtObjects(objectList, getLabel, selectNode, handleOptionClick);
                });
            });
            let tecLabel = "";
            let tecValue = -1;
            if (store.lastOrder.delivery_adr_id) {
                tecValue = store.lastOrder.delivery_adr_id;
                tecLabel = store.nameKeyOtObject.get(store.lastOrder.delivery_adr_id) ? store.nameKeyOtObject.get(store.lastOrder.delivery_adr_id) : "";
            }
            const tecadrWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(tecadrWrapperNode, 'h2', [], [], 'Wo steht das Ding?');
            const techlocationAddressNode = DomHelper.appendFilteringSelect(tecadrWrapperNode, 'techlocationadr', tecLabel, tecValue, `techlocationadr-${product.id}`, (query, selectNode, inputNode) => {
                let searchstring = "";
                if (query.includes('*'))
                    searchstring = query;
                else
                    searchstring = `${query.trim()}*`;
                if (searchstring.length < 3)
                    return;
                function handleOptionClick(event) {
                    updateInputField(event, inputNode, selectNode);
                }
                let objectList = [];
                if (store.lastSearchString != "" && query.startsWith(store.lastSearchString)) {
                    objectList = filterAddressQueryResult(query);
                    renderResults(selectNode, objectList, getLabelOtAdr, handleOptionClick, query);
                }
                else {
                    getShopBackendData('', `/search/addresses/?search=${searchstring}`, 'GET', 'application/json', bearerToken, (response) => {
                        const results = JSON.parse(response.target.response);
                        objectList = results.objectList;
                        store.addressQueryResult = objectList;
                        if (objectList.length == 1) {
                            const adr = objectList[0];
                            setInputFieldValue(inputNode, adr.id + '', getLabelOtAdr(adr), selectNode);
                            DomHelper.setFocus(orderDetailNode, '[name=building]');
                        }
                        else {
                            renderResults(selectNode, objectList, getLabelOtAdr, handleOptionClick, query);
                        }
                        storeOtObjects(objectList, getLabelOtAdr, selectNode, handleOptionClick);
                    });
                }
            });
            const buildingNode = DomHelper.appendDivAsInput(tecadrWrapperNode, [], 'building', 'Gebäude', store.lastOrder.building, `building-${product.id}`);
            DomHelper.appendNode(tecadrWrapperNode, "div", ['od-form-invalid-msg', 'disabled'], [], '', `building-${product.id}-invalid`);
            const roomNode = DomHelper.appendDivAsInput(tecadrWrapperNode, [], 'room', 'Raum', store.lastOrder.room, `room-${product.id}`);
            DomHelper.appendNode(tecadrWrapperNode, "div", ['od-form-invalid-msg', 'disabled'], [], '', `room-${product.id}-invalid`);
            let deliverLabel = "";
            let deliverValue = -1;
            if (store.lastOrder.delivery_adr_id) {
                deliverValue = store.lastOrder.delivery_adr_id;
                deliverLabel = store.nameKeyOtObject.get(store.lastOrder.delivery_adr_id) ? store.nameKeyOtObject.get(store.lastOrder.delivery_adr_id) : "";
            }
            const deliverWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(deliverWrapperNode, 'h2', [], [], 'Wohin soll geliefert werden?');
            const deliveryAddressNode = DomHelper.appendFilteringSelect(deliverWrapperNode, 'deliveradr', deliverLabel, deliverValue, `deliveradr-${product.id}`, (query, selectNode, inputNode) => {
                let searchstring = "";
                if (query.includes('*'))
                    searchstring = query;
                else
                    searchstring = `${query.trim()}*`;
                if (searchstring.length < 3)
                    return;
                function handleOptionClick(event) {
                    updateInputField(event, inputNode, selectNode);
                }
                let objectList = [];
                if (store.lastSearchString != "" && query.startsWith(store.lastSearchString)) {
                    objectList = filterAddressQueryResult(query);
                    renderResults(selectNode, objectList, getLabelOtAdr, handleOptionClick, query);
                }
                else {
                    getShopBackendData('', `/search/addresses/?search=${searchstring}`, 'GET', 'application/json', bearerToken, (response) => {
                        const results = JSON.parse(response.target.response);
                        objectList = results.objectList;
                        store.addressQueryResult = objectList;
                        if (objectList.length == 1) {
                            const adr = objectList[0];
                            setInputFieldValue(inputNode, adr.id + '', getLabelOtAdr(adr), selectNode);
                            DomHelper.setFocus(orderDetailNode, '[name=invoiceadr-input]');
                        }
                        else {
                            renderResults(selectNode, objectList, getLabelOtAdr, handleOptionClick, query);
                        }
                        storeOtObjects(objectList, getLabelOtAdr, selectNode, handleOptionClick);
                    });
                }
            });
            let recLabel = "";
            let recValue = -1;
            if (store.lastOrder.invoice_adr_id) {
                recValue = store.lastOrder.invoice_adr_id;
                recLabel = store.nameKeyOtObject.get(store.lastOrder.invoice_adr_id) ? store.nameKeyOtObject.get(store.lastOrder.invoice_adr_id) : "";
            }
            const invoiceWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(invoiceWrapperNode, 'h2', [], [], 'Wohin soll die Rechnung?');
            const invoiceAddressNode = DomHelper.appendFilteringSelect(invoiceWrapperNode, 'invoiceadr', recLabel, recValue, `invoiceadr-${product.id}`, (query, selectNode, inputNode) => {
                let searchstring = "";
                if (query.includes('*'))
                    searchstring = query;
                else
                    searchstring = `${query.trim()}*`;
                if (searchstring.length < 3)
                    return;
                function handleOptionClick(event) {
                    updateInputField(event, inputNode, selectNode);
                }
                let objectlist = [];
                if (store.lastSearchString != "" && query.startsWith(store.lastSearchString)) {
                    objectlist = filterAddressQueryResult(query);
                    renderResults(selectNode, objectlist, getLabelOtAdr, handleOptionClick, query);
                }
                else {
                    getShopBackendData('', `/search/addresses/?search=${searchstring}`, 'GET', 'application/json', bearerToken, (response) => {
                        const results = JSON.parse(response.target.response);
                        objectlist = results.objectList;
                        store.addressQueryResult = objectlist;
                        if (objectlist.length == 1) {
                            const adr = objectlist[0];
                            setInputFieldValue(inputNode, adr.id + '', getLabelOtAdr(adr), selectNode);
                            DomHelper.setFocus(orderDetailNode, '[name=remark]');
                        }
                        else {
                            renderResults(selectNode, objectlist, getLabelOtAdr, handleOptionClick, query);
                        }
                    });
                    storeOtObjects(objectlist, getLabelOtAdr, selectNode, handleOptionClick);
                }
            });
            const descWrapperNode = DomHelper.appendNode(orderDetailNode, 'div', ['od-input-wrapper']);
            DomHelper.appendNode(descWrapperNode, 'h2', [], [], 'Anmerkung');
            const descNode = DomHelper.appendDivAsInput(descWrapperNode, ['od-no-label'], 'remark', '', '', 'remark-input');
            const buttonNode = DomHelper.appendNode(orderDetailNode, 'button', ['btn', 'btn-primary', 'center', 'mt-4'], [{
                    attr: 'id',
                    value: ''
                }]);
            DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-cart-plus'], []);
            DomHelper.appendNode(buttonNode, 'span', [], [], 'In den Warenkorb legen.');
            inputNodeList.push({
                node: enduserNode,
                required: true,
                pattern: "^[0-9]+$",
                errormessage: "Bitte wählen Sie eine Person aus, für die bestellt wird."
            });
            inputNodeList.push({
                node: costcenterNode,
                required: true,
                errormessage: "Die Angabe der Kostenstelle ist erforderlich."
            });
            inputNodeList.push({ node: deliveryAddressNode, required: true });
            inputNodeList.push({ node: invoiceAddressNode, required: true });
            inputNodeList.push({ node: techlocationAddressNode, required: true });
            inputNodeList.push({ node: amountNode, required: true });
            inputNodeList.push({ node: buildingNode, required: true });
            inputNodeList.push({ node: roomNode, required: true });
            inputNodeList.push({ node: descNode, required: false });
            if (((_b = product.ciType) === null || _b === void 0 ? void 0 : _b.name) == "Smartphone") {
                inputNodeList.push({ node: phoneNumberNode, required: false });
            }
            inputNodeList.push({
                node: buttonNode,
                required: false
            });
            buttonNode.addEventListener('click', (event) => {
                var _a;
                let newOptions = getOptionsFromProductCard(cardNode);
                const isValid = validateForm(inputNodeList);
                const contract_id = contractValue.getAttribute('value');
                const phone_number = hiddenPhoneNode.getAttribute('value');
                const proceedToCart = () => {
                    if (isValid) {
                        let items = {
                            product_id: product.id,
                            amount: Number(amountNode.innerHTML),
                            end_user_id: Number(enduserNode.getAttribute('value')),
                            costcenter_id: Number(costcenterNode.getAttribute('value')),
                            remark: getRemarkString(descNode.innerText, contract_id, phone_number),
                            location_id: Number(techlocationAddressNode.getAttribute('value')),
                            invoice_adr_id: Number(invoiceAddressNode.getAttribute('value')),
                            delivery_adr_id: Number(deliveryAddressNode.getAttribute('value')),
                            building: buildingNode.innerHTML,
                            room: roomNode.innerHTML,
                            options: newOptions,
                            phone_number_id: Number(phoneNumberNode.getAttribute('value'))
                        };
                        store.lastOrder = items;
                        if (DEBUG)
                            console.log("Store", store);
                        add2Cart(userid, bearerToken, items, product.name, allProductList);
                        orderDetailNode.innerHTML = "";
                        orderDetailNode.classList.add('disabled');
                        addOpenFormNodeButton(product.id ? product.id.toString() : 'none');
                        DomHelper.scrollIntoView(cardNode).finally();
                    }
                };
                if (((_a = product.ciType) === null || _a === void 0 ? void 0 : _a.name) == "Smartphone") {
                    const login_name = hiddenLoginNameNode.getAttribute('value');
                    const user_name = hiddenLoginName.getAttribute('value');
                    if (login_name != user_name) {
                        console.log('Login name and user name do not match');
                        DomHelper.showConfirmationMessage({
                            type: 'warn',
                            header: 'Warnung',
                            icon: 'fa-cart-circle-exclamation',
                            message: 'Endnutzer und Vertragsinhaber stimmen nicht überein. Soll es trotzdem in den Warenkorb gelegt werden?',
                            interaction: {
                                label: 'In Warenkorb legen'
                            }
                        }).then((isConfirmed) => {
                            if (isConfirmed) {
                                store.phoneStore.phoneuser = login_name;
                                store.phoneStore.enduser = user_name;
                                proceedToCart();
                            }
                        });
                        return;
                    }
                }
                proceedToCart();
            });
        }
    }
    function getRemarkString(remark, contract_id, phonenumber) {
        let result = "";
        if (remark && remark.length > 0) {
            result = remark;
        }
        if (contract_id) {
            if (result.length > 0) {
                result = result + '&#x000d;&#x000a;';
            }
            result = `${result}[V: ${contract_id}]`;
        }
        if (phonenumber) {
            if (result.length > 0) {
                result = result + '&#x000d;&#x000a;';
            }
            result = `${result}[T: ${phonenumber}]`;
        }
        return result;
    }
    function addOpenFormNodeButton(otid) {
        const buttonArea = cardNode.querySelector('.od-product-button-area');
        if (buttonArea) {
            const buttonNode = DomHelper.appendNode(buttonArea, 'button', ['btn', 'btn-primary', 'center', 'mt-4'], [{
                    attr: 'id',
                    value: `${otid}-open-form-node-button`
                }]);
            DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-cart-plus'], []);
            DomHelper.appendNode(buttonNode, 'span', [], [], 'Details erfassen');
            buttonNode.addEventListener('click', (event) => {
                buttonArea.innerHTML = "";
                renderOrderForm();
            });
        }
    }
    if (cardMainNode) {
        DomHelper.disableNodesByClassList(cardMainNode, ['od-product-desc']);
        DomHelper.enableNodesByClassList(cardNode, ['od-product-order']);
        DomHelper.removeNodesByClassList(cardMainNode, ['od-product-desc-long']);
        const cardOrderNode = cardNode.querySelector('.od-product-order');
        cardOrderNode.innerHTML = "";
        const descNode = DomHelper.appendNode(cardMainNode, 'div', ['od-product-desc-long'], []);
        const htmlContent = marked(product.description);
        if (typeof (htmlContent) == "string")
            descNode.innerHTML = htmlContent;
        if (product.attachments.length > 1) {
            DomHelper.appendNode(cardMainNode, 'h3', ['od-product-documents'], [], 'Dokumente');
            for (const attachment of product.attachments) {
                if (attachment.type == "pdf") {
                    const attNode = DomHelper.appendNode(cardMainNode, 'p', ['od-product-document'], []);
                    DomHelper.appendNode(attNode, 'i', ['fa-light', 'fa-file-pdf'], []);
                    DomHelper.appendNode(attNode, 'a', [], [{ attr: 'href', value: `./assets/${attachment.file}` }, { attr: 'target', value: `_blank` }], attachment.name);
                }
            }
        }
        if (product.options && product.options.length > 0 && cardOrderNode) {
            const optionsNode = DomHelper.appendNode(cardOrderNode, 'div', ['od-product-options'], []);
            DomHelper.appendNode(optionsNode, 'h2', [], [], 'Optionen');
            for (const opt of product.options) {
                renderOption(cardNode, optionsNode, opt);
            }
        }
        addOpenFormNodeButton(product.id ? product.id.toString() : 'none');
    }
}
function hideProductDetail(cardNode) {
    cardNode.classList.remove('rudi-row-span-2');
    cardNode.classList.remove('rudi-col-span-2');
    const cardMainNode = cardNode.querySelector('.od-product-main');
    if (cardMainNode) {
        const descShortNode = cardMainNode.querySelector('.od-product-desc');
        if (descShortNode)
            descShortNode.classList.remove('disabled');
        DomHelper.removeNodesByClassList(cardNode, ['od-product-desc-long', 'od-product-options', 'od-product-documents']);
        DomHelper.removeAllNodesByClassList(cardNode, ['od-product-document']);
        DomHelper.disableNodesByClassList(cardNode, ['od-product-order', 'od-order-detail']);
        const buttonArea = cardNode.querySelector('.od-product-button-area');
        if (buttonArea) {
            buttonArea.innerHTML = "";
        }
    }
}
function extractContractNumberFromRemarkCache(remark) {
    if (!remark)
        return '';
    let c_rgx = remark.match(/\[V:\s*(V-\d{8})\s*\]/);
    if (c_rgx) {
        return c_rgx[1].trim();
    }
    return '';
}
function extractPhoneNumberFromRemarkCache(remark) {
    if (!remark)
        return '';
    let c_rgx = remark.match(/\[T:\s*([^\]]+)\]/);
    if (c_rgx) {
        return c_rgx[1].trim();
    }
    return '';
}
function renderProductPreview(parentElement, product, userid, bearerToken, allProductList, skeleton = false) {
    const additionalClassList = [];
    if (skeleton)
        additionalClassList.push('skeleton');
    const cardNode = DomHelper.appendNode(parentElement, 'article', [...additionalClassList, 'od-product-card'], [{
            attr: 'otid',
            value: `${product ? product.id : ""}`
        }]);
    const cardMainNode = DomHelper.appendNode(cardNode, 'section', [...additionalClassList, 'od-product-main'], [{
            attr: 'otid',
            value: `${product ? product.id : ""}`
        }]);
    let detailView = false;
    if (product && allProductList) {
        cardMainNode.addEventListener('click', (event) => {
            if (!detailView) {
                renderProductDetail(cardNode, product, userid, bearerToken, allProductList);
                detailView = true;
            }
            else {
                hideProductDetail(cardNode);
                detailView = false;
            }
        });
    }
    DomHelper.appendNode(cardMainNode, 'h2', [], [], product ? product.name : "");
    if (product && product.attachments.length > 0) {
        const image = product.attachments.find(img => img.type == "png");
        DomHelper.appendNode(cardMainNode, 'img', ['od-product-img'], [{ attr: 'src', value: `./assets/${image.file}` }]);
    }
    else if (skeleton) {
        DomHelper.appendNode(cardMainNode, 'div', ['od-product-img', 'skeleton'], []);
    }
    let description = "";
    if (product && product.description) {
        if (product.description.length > 100) {
            description = `${product.description.substring(0, 100)}&#133;`;
        }
        else {
            description = product.description;
        }
    }
    DomHelper.appendNode(cardMainNode, 'div', [...additionalClassList, 'od-product-desc'], [], description);
    const orderNode = DomHelper.appendNode(cardNode, 'div', ['od-product-order', 'disabled'], []);
    const footerNode = DomHelper.appendNode(cardNode, 'div', [...additionalClassList, 'od-product-footer'], []);
    const orderDetailNode = DomHelper.appendNode(cardNode, 'div', ['od-order-detail', 'disabled'], []);
    const buttonArea = DomHelper.appendNode(cardNode, 'div', ['od-product-button-area'], []);
    DomHelper.appendNode(footerNode, 'div', [...additionalClassList, 'od-product-price-type'], [], product ? product.priceType : "");
    DomHelper.appendNode(footerNode, 'div', [...additionalClassList, 'od-product-price'], [{
            attr: 'price',
            value: product ? product.price.toString() : ""
        }], Util.number2money(Number(product ? product.price : 3.14), 'EUR'));
}
function productListRender(parentElement, userid, bearerToken, userPreferences, response, skeleton = false) {
    const additionalClassList = [];
    if (skeleton)
        additionalClassList.push('skeleton');
    if (response) {
        const productList = response.productList;
        const categoryListSorted = response.categoryList.sort((a, b) => {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        });
        for (const cat of categoryListSorted) {
            const catNode = renderCategory(parentElement, cat, skeleton);
            const gridNode = DomHelper.appendNode(catNode, 'section', [...additionalClassList, 'od-shop-grid'], []);
            const productSubset = productList.filter(item => {
                var _a;
                return ((_a = item.ciType) === null || _a === void 0 ? void 0 : _a.name) === cat.name;
            });
            const productSubsetSorted = productSubset.sort((a, b) => {
                if (a.price < b.price)
                    return -1;
                if (a.price > b.price)
                    return 1;
                return 0;
            });
            for (const prod of productSubsetSorted) {
                renderProductPreview(gridNode, prod, userid, bearerToken, productList);
            }
        }
    }
    else {
        const catNode = renderCategory(parentElement, null, skeleton);
        const gridNode = DomHelper.appendNode(catNode, 'section', [...additionalClassList, 'od-shop-grid'], []);
        for (let i = 0; i < 10; i++) {
            renderProductPreview(gridNode, null, userid, bearerToken, null, skeleton);
        }
    }
}
function toggleCategory(category) {
    const categoryNode = document.getElementById(`category-${category.id}`);
    if (categoryNode) {
        const iconNode = categoryNode === null || categoryNode === void 0 ? void 0 : categoryNode.querySelector('i');
        const shopGrid = categoryNode === null || categoryNode === void 0 ? void 0 : categoryNode.querySelector('.od-shop-grid');
        if (iconNode && iconNode.classList.contains(iconOpenGroup)) {
            iconNode.classList.remove(iconOpenGroup);
            iconNode.classList.add(iconClosedGroup);
            if (shopGrid) {
                shopGrid.classList.add('disabled');
            }
        }
        else if (iconNode) {
            iconNode.classList.add(iconOpenGroup);
            iconNode.classList.remove(iconClosedGroup);
            if (shopGrid) {
                shopGrid.classList.remove('disabled');
            }
        }
    }
}
function renderCategory(parentElement, cat, skeleton = false) {
    const additionalClassList = [];
    if (skeleton)
        additionalClassList.push('skeleton');
    const sectionHeader = DomHelper.appendNode(parentElement, "section", [...additionalClassList, 'rudi-app-group-header'], [{
            attr: 'id',
            value: `category-${cat ? cat.id : ""}`
        }]);
    const h1 = DomHelper.appendNode(sectionHeader, 'h1', [...additionalClassList], []);
    let iconClasses = ['fa-solid', iconOpenGroup];
    let iconNode = DomHelper.appendNode(h1, 'i', iconClasses, [{ attr: "id", value: (cat ? cat.id : "") + "_icon" }]);
    DomHelper.appendNode(h1, 'span', [...additionalClassList], [], cat ? cat.name : "");
    if (cat) {
        h1.addEventListener('click', () => {
            toggleCategory(cat);
        });
    }
    return sectionHeader;
}
function captureSearchBar(products) {
    const searchBarWrapperNode = document.querySelector('section.top-search-bar-wrapper');
    if (searchBarWrapperNode) {
        const oldsearchBar = searchBarWrapperNode.querySelector('.top-search-bar');
        if (oldsearchBar.classList.contains('disabled'))
            return;
        if (oldsearchBar) {
            oldsearchBar.classList.add('disabled');
        }
        const orderSearchbar = document.getElementById('odOrderSearchbar');
        if (orderSearchbar)
            return;
        const inputNode = DomHelper.appendNode(searchBarWrapperNode, 'div', ['top-search-bar'], [{
                attr: 'contenteditable',
                value: 'true'
            }, { attr: 'searchbase', value: 'apps' }], '', 'odProductSearchbar');
        inputNode.addEventListener('input', (event) => {
            const searchTerm = event.target.innerText.trim().toLowerCase();
            let filteredApps = [];
            let filter = products.filter(product => {
                var _a;
                return product.name.toLowerCase().includes(searchTerm) ||
                    product.priceType.toLowerCase().includes(searchTerm) ||
                    ((_a = product.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchTerm.toLowerCase()));
            });
            filteredApps.push(...filter);
            const activeNodes = document.querySelectorAll('.od-product-card');
            for (const activeElement of activeNodes) {
                if (filteredApps.some(appInfo => appInfo.id.toString() === activeElement.getAttribute('otid'))) {
                    activeElement.classList.remove('disabled');
                }
                else {
                    activeElement.classList.add('disabled');
                }
            }
            DomHelper.updateCategoryVisibility('odWebshopPane', 'rudi-app-group-header', 'od-shop-grid', 'od-product-card');
        });
    }
}
function captureOrderSearchbar() {
    const searchBarWrapperNode = document.querySelector('section.top-search-bar-wrapper');
    console.log("captureOrderSearchbar");
    if (searchBarWrapperNode) {
        const oldsearchBar = searchBarWrapperNode.querySelector('#odProductSearchbar');
        if (oldsearchBar.classList.contains('disabled'))
            return;
        if (oldsearchBar) {
            oldsearchBar.classList.add('disabled');
        }
        console.log("Disabled oldSearchbar");
        const oldOrdersearchBar = searchBarWrapperNode.querySelector('#odOrderSearchbar');
        if (oldOrdersearchBar) {
            oldOrdersearchBar.classList.remove('disabled');
            return;
        }
        const inputNode = DomHelper.appendNode(searchBarWrapperNode, 'div', ['top-search-bar'], [{
                attr: 'contenteditable',
                value: 'true'
            }, { attr: 'searchbase', value: 'apps' }], '', 'odOrderSearchbar');
        const orderList = document.getElementById('odWebshopOrderList');
        const getRowText = (row) => {
            const cells = row.querySelectorAll("td");
            return Array.from(cells)
                .map((cell) => { var _a; return (_a = cell.textContent) !== null && _a !== void 0 ? _a : ""; })
                .join(" ");
        };
        const cleanString = (text) => {
            return text.toLowerCase().trim().replace(/\s+/g, " ");
        };
        inputNode.addEventListener('input', (event) => {
            const searchTerm = cleanString(event.target.innerText);
            console.log("SearchTerm: " + searchTerm);
            const orderCards = orderList.querySelectorAll("article");
            orderCards.forEach((card) => {
                let cardHasMatch = false;
                const rows = card.querySelectorAll("table tbody tr");
                rows.forEach((row) => {
                    const rowText = cleanString(getRowText(row));
                    const isMatch = searchTerm === "" || rowText.includes(searchTerm);
                    row.classList.toggle('disabled', !isMatch);
                    if (isMatch) {
                        console.log("Match found in row: " + rowText);
                        cardHasMatch = true;
                    }
                });
                card.classList.toggle('disabled', !cardHasMatch);
            });
        });
    }
}
